import React from 'react';
import { Experience } from './experience';

export const ExperienceCard = ({experience,downloadUrl})=> {
    console.log(downloadUrl,"DOWNLOADURL")
    return (
        <section>
        <div class="d-flex align-items-center justify-content-between mb-4">
            <h2 class="text-primary fw-bolder mb-0">Experience</h2>
            <a class="btn btn-primary px-4 py-3" href={downloadUrl} target='__blank'>
                <div class="d-inline-block bi bi-download me-2"></div>
                Download Resume
            </a>
        </div>
        {experience?.map(({years,title,company,description,location})=>
          <Experience
             duration={years}
             jobTitle={title}
             company={company}
             location={location}
             description={description}
          />
        )}
    </section>
    )
}